import { FC } from 'react';
import { css } from '@linaria/atomic';
import { Text } from '../../..';
import { NakedUl } from '../../../../naked';

const optionGroupTextStyle1 = css`
  margin: 8px 4px 4px 16px;
  &:first-letter {
    text-transform: capitalize;
  }
`;

const optionGroupNakedUlStyle2 = css`
  li:not(:first-of-type) {
    padding: 8px 16px 8px 32px;
  }
`;

export type OptionGroupProps = {
  label: string;
};

export const OptionGroup: FC<React.PropsWithChildren<OptionGroupProps>> = ({ children, label, ...rest }) => {
  return (
    <li>
      <NakedUl className={optionGroupNakedUlStyle2}>
        <Text as='li' size='large' weight='bold' className={optionGroupTextStyle1} {...rest}>
          {label || ''}
        </Text>
        {children}
      </NakedUl>
    </li>
  );
};
